// @flow

import React, { type Node } from 'react';
import { TipsBox } from '../../../../../../organisms/tips-box';


import qrCodeTipSrc from './tip-qr-code.svg';
import copyPasteTipSrc from './tip-copy-paste.svg';
import smartphoneConfirmationTipSrc from './tip-smartphone-confirmation.svg';


export function Tips(): Node {
  return (
    <TipsBox
      title="Como pagar com o Pix"
      tipsModel={[
        {
          imgSrc: copyPasteTipSrc,
          altText: 'copy paste icon',
          tipText: 'Copie o código Pix acima e cole no app do seu banco ou carteira digital.',
        },
        {
          imgSrc: qrCodeTipSrc,
          altText: 'qrcode icon',
          tipText: 'Utilize o app de seu banco ou carteira digital para escanear o código QR gerado.',
        },
        {
          imgSrc: smartphoneConfirmationTipSrc,
          altText: 'smartphone confirmation icon',
          tipText: 'Seu pagamento será aprovado em alguns instantes.',
        },
      ]}
    />
  );
}
